import { BackButton } from './BackButton';

export const HeaderBanner = ({
  label,
  href,
}: {
  label?: string;
  href?: string;
}) => {
  return (
    <div className="header-banner" data-testid="header-banner">
      <div className="header-banner__layout">
        <BackButton label={label} href={href} />
      </div>
    </div>
  );
};
